import React from 'react'
import PropTypes from 'prop-types'

const MenuLink = ({ url, label, onClick }) => {
  let link
  const setRef = linkRef => {
    if (linkRef) {
      link = linkRef
      link.addEventListener('auxclick', onClick)
    } else {
      link.removeEventListener('auxclick', onClick)
    }
  }

  return (
    <a
      href={url}
      onClick={onClick}
      ref={setRef}
    >{label}</a>
  )
}

MenuLink.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}

export default MenuLink
